<template>
  <div class="b-points" v-if=" store.showPointsBox">
    <div class="b-points__info">
      <div class="b-points__profile">
        <div class="b-points__avatar">
          <img
            v-if="store.accountData && store.accountData.avatar"
            :src="store.accountData.avatar.url"
            :alt="store.accountData.avatar.alt" />
          <img v-else src="/assets/imgs/icons/no-avatar.png" alt="" />
        </div>

        <span> {{ store.accountData ? store.accountData.lastName : null }}</span>
      </div>
      <div class="e-label e-label--bg">
        {{ store.accountData ? store.accountData.clubName : "" }}
      </div>
    </div>

    <div class="b-points__user-points">
      <span class="b-points__txt">{{ dictionary.currentPointsText }}</span>
      <span class="b-points__points">{{ store.getUserPoints }}</span>
    </div>

    <div class="b-points__used-points" v-if="showAUsedPoints">
      <span class="b-points__txt">{{ dictionary.usedPointsText }}</span>
      <span>-{{ store.getTotalUsedPoints }}</span>
    </div>

    <div class="b-points__available-points" v-if="showAvailablePoints">
      <span class="b-points__txt">{{ dictionary.availablePointsText }}</span>
      <span class="b-points__points">{{ store.getRemainPoints }}</span>
    </div>

    <div class="b-points__infoText" v-if="dictionary.pointsInfoText">
      {{ dictionary.pointsInfoText }}
    </div>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue'
import { useBookingStore } from '../../../store/BookingStore'

import constants from '../../../../lib/constants'

const { dictionary } = getCurrentInstance().appContext.config.globalProperties
const store = useBookingStore()
const { selectedTickets } = store.bookingProgress

const showAvailablePoints = computed(() => {
  return store.getRemainPoints !== store.getUserPoints ? true : false
})

const showAUsedPoints = computed(() => {
  return store.getTotalUsedPoints > 0 ? true : false
})
</script>
